import BaseRoute from 'seshy/routes/base';

export default class AboutRoute extends BaseRoute {}
